import {
  Card,
  CardContent,
  CardHeader,
  H5,
  SmallButton,
} from "@sellar-io/components";
import { PriceTierOrderRule } from "@sellar-io/api-v2/types";
import { List, ListElement } from "../../../components";
import { generatePriceTierOrderRuleDescription } from "../../../utils/sellarHelpers";
import { useState } from "react";
import { OrderRuleDialogCreate } from "./components/OrderRuleDialogCreate";
import { OrderRuleDialogUpdate } from "./components/OrderRuleDialogUpdate";

export const OrderRulesEdit = ({
  orderRulesId,
  rules,
}: {
  orderRulesId: number | null;
  rules: Pick<PriceTierOrderRule, "id" | "itemType" | "quantity">[];
}) => {
  const [dialogActive, setDialogActive] = useState(false);

  return (
    <>
      <Card className="bg-white">
        <CardHeader className="bg-white p-4">
          <H5>Minimum order quantities</H5>
          <span className="text-zinc-500">
            When setting multiple minimum order quantities, only one has to be
            met.
          </span>
        </CardHeader>
        <CardContent className={"flex flex-col gap-3 p-4"}>
          {!rules.length ? (
            <div>No minimum item quantity rules</div>
          ) : (
            <List>
              {rules.map((rule) => (
                <PriceTierOrderRuleListElement rule={rule} key={rule.id} />
              ))}
            </List>
          )}
          <SmallButton
            onClick={() => {
              setDialogActive(true);
            }}
          >
            Add minimum order rule
          </SmallButton>
        </CardContent>
      </Card>
      <OrderRuleDialogCreate
        orderRulesId={orderRulesId}
        active={dialogActive}
        onDismiss={() => setDialogActive(false)}
      />
    </>
  );
};

const PriceTierOrderRuleListElement = ({
  rule,
}: {
  rule: Pick<PriceTierOrderRule, "id" | "itemType" | "quantity">;
}) => {
  const [editDialogActive, setEditDialogActive] = useState(false);

  return (
    <>
      <ListElement
        promptText={"Edit"}
        onClick={() => {
          setEditDialogActive(true);
        }}
      >
        {generatePriceTierOrderRuleDescription(rule)}
      </ListElement>
      <OrderRuleDialogUpdate
        priceTierOrderRule={rule}
        active={editDialogActive}
        onDismiss={() => setEditDialogActive(false)}
      />
    </>
  );
};
